import { useQuery } from '@tanstack/react-query'
import { fetchTutorialsAndDemosArticles, TutorialOrDemoArticle } from '../service/guide.service'

export const useTutorialsAndDemos = () => {
  return useQuery<TutorialOrDemoArticle[]>({
    queryKey: ['tutorials-and-demos-articles'],
    queryFn: fetchTutorialsAndDemosArticles,
  })
}
